// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"1a47acdb","591":"e9b1e1e0","620":"2197b2b5","641":"2c0f1557","772":"4c02e323","906":"5501d6a8","973":"27b31c00"}[chunkId] + ".chunk.js";
};